import Vue from 'vue';

Vue.component('c-button', () => import('@/app/ui/Button'));
Vue.component('c-checkbox', () => import('@/app/ui/Checkbox'));
Vue.component('c-radio', () => import('@/app/ui/Radio'));
Vue.component('c-pill', () => import('@/app/ui/Pill'));
Vue.component('c-datepicker', () => import('@/app/ui/DatePickerInput'));

Vue.component('c-choice', () => import('@/app/components/Choice'));
Vue.component('c-choice-nullable', () => import('@/app/components/ChoiceNullable'));
Vue.component('c-choice-child', () => import('@/app/components/ChoiceChild'));
Vue.component('c-nav', () => import('@/app/components/Nav'));

Vue.component('c-cart', () => import('@/app/components/Cart'));
Vue.component('c-cart-kiosk', () => import('@/app/components/CartKiosk'));

Vue.component('c-cart-peak', () => import('@/app/components/CartPeak'));
Vue.component('c-cart-item', () => import('@/app/components/CartItem'));

Vue.component('c-timeline', () => import('@/app/components/Timeline'));
Vue.component('c-controls', () => import('@/app/components/Controls'));

Vue.component('c-section-header', () => import('@/app/components/SectionHeader'));
Vue.component('c-spinner', () => import('@/app/components/Spinner'));

Vue.component('c-fixed-container', () => import('@/app/components/FixedContainer'));

Vue.component('c-price-information', () => import('@/app/components/PriceInformation'));



// WEBPACK FOOTER //
// ./src/app/components/_register.js